export default "__VITE_ASSET__D9doyud2__"